import { DataDefinition } from "../Data/DataDefinition";
import { IConfigStorage } from "../IConfigStorage";

export abstract class BaseExecutable implements IConfigStorage {
    inputData?: DataDefinition | (() => DataDefinition);

    get canChangeInputs(): boolean {
        return !this.inputData || !(this.inputData instanceof Function);
    }

    getInputDefinition(): DataDefinition {
        if (!this.inputData) {
            this.inputData = new DataDefinition();
            return this.inputData;
        }

        if (this.inputData instanceof Function) {
            return this.inputData();
        } else {
            return this.inputData;
        }
    }

    getStorageData(): object {
        let data = {};

        if (this.inputData && !(this.inputData instanceof Function)) {
            Reflect.set(data, "inputData", this.getInputDefinition().getStorageData());
        }

        return data;
    }

    setStorageData(data: object): void {
        let idata = Reflect.get(data, "inputData");

        if (idata) {
            this.inputData = new DataDefinition();
            this.inputData.setStorageData(idata);
        }
    }
}
